import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * POM-6010 — the guard on closing the review with edits still uncommitted.
 *
 * Applying a change writes nothing, so closing the dialog silently throws the work away. This says
 * so before it happens, and names the consequence that actually matters: the labels will print with
 * the original lots.
 *
 * A backdrop click is inert here too. Dismissing this prompt by accident reads as "keep editing",
 * but it sits one click from the discard button.
 */
const DiscardLotNdcChangesDialog = ({ open, changedCount, onKeepEditing, onDiscard }) => {
  const many = changedCount > 1;

  return (
    <Dialog open={open} onClose={(event, reason) => reason !== 'backdropClick' && onKeepEditing()}>
      <DialogTitle>Discard uncommitted changes?</DialogTitle>
      <DialogContent>
        <Typography variant='body2'>
          {`${changedCount} change${many ? 's have' : ' has'} not been committed. Closing now `}
          {`discards ${many ? 'them' : 'it'} and the labels will print with the original lots.`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onKeepEditing}>Keep editing</Button>
        <Button color='error' onClick={onDiscard}>
          Discard and close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DiscardLotNdcChangesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  changedCount: PropTypes.number.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
};

export default DiscardLotNdcChangesDialog;
